/* unplugin-vue-components disabled */import { render } from "./ghsave.vue?vue&type=template&id=51ea2284"
import script from "./ghsave.vue?vue&type=script&lang=js"
export * from "./ghsave.vue?vue&type=script&lang=js"

import "./ghsave.vue?vue&type=style&index=0&id=51ea2284&lang=less"

import exportComponent from "E:\\vuewebpage3\\ydqbyg-dz2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__